import * as CONST from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  contentInfo: {},
  AUDLoading: false
};

 /**
      * Used for handle response of terms-conditions and privacy policy
      */

const Content = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONST.GET_CONTENT:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_CONTENT_SUCCESS:
      return {
        ...state,
        contentInfo: action.payload.data || {},
        loading: false,
        error: "",
      };

    case CONST.GET_CONTENT_FAIL:
      return {
        ...state,
        contentInfo: {},
        loading: false,
        error: "",
      };
  
    
    default:
      return state;
  }
};

export default Content;
